import { React, useState, useEffect } from "react";
import userCarsIcon from "../../assets/images/car-inspection/user-cars-icon.svg";

import carPartsImage from "../../assets/images/car-inspection/car-parts.png";



import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";


import axios from 'axios';
import { BASE_IMAGE_URL, BASE_URL } from '../../config';
import { Markup } from 'interweave';
import { toast } from "react-toastify";
import { Link } from 'react-router-dom';
import FaqData from "../../constants/FaqData";
import FAQSection from "../../partials/FAQSection";

function CarInspection({ isShowLoader }) {
  let [isLoading, setIsLoading] = useState(false);
  let [bannerData, setBannerData] = useState([]);
  let [coverData, setCoverData] = useState([]);
  let [howItsData, setHowItsWorkData] = useState([]);
  let [faqData, setFaqData] = useState([]);
  let [interactiveData, setInteractiveData] = useState([]);
  let [urlData, seturlData] = useState([]);
  let [helpfulData, setHelpfulData] = useState([]);
  let [factsData, setFactsData] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: "", contact: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "contact") {
      // Allow only numbers, with optional leading '+', max length 10 digits
      if (/^\+?\d{0,10}$/.test(value)) {
        setFormData({ ...formData, [name]: value });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };


  const handleSubmit = async () => {
    if (!formData.name.trim()) {
      toast.error("Name is required!");
      return;
    }

    if (!formData.contact.trim()) {
      toast.error("Contact number is required!");
      return;
    }

    if (!/^\d{10}$/.test(formData.contact)) {
      toast.error("Contact number must be exactly 10 digits!");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/add-callback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (data.status == 200) {
        toast.success("Callback request submitted successfully!");
        //alert("Callback request submitted successfully!");
        setShowModal(false);
        setFormData({ name: "", contact: "" });
      } else {
        alert("Error: " + JSON.stringify(data.errors));
      }
    } catch (error) {
      console.error("Error submitting request:", error);
    }
  };



  let fetchData = async () => {
    try {
      await axios.get(`${BASE_URL}/car-inspection-home`)
        .then(res => {
          if (res.data.responseCode === 200) {
            console.log(res.data.responseData.banner);
            setBannerData(res.data.responseData.banner);
            setCoverData(res.data.responseData.cover);
            setHowItsWorkData(res.data.responseData.howIts);
            setFaqData(res.data.responseData.faq);
            setInteractiveData(res.data.responseData.interactiveCar);
            seturlData(res.data.responseData.interactiveUrl);
            setHelpfulData(res.data.responseData.inspectionHelpful);
            setFactsData(res.data.responseData.facts);

          }
        })
    } catch (error) {
      console.log(error);

    }
  }


  useEffect(() => {
    isShowLoader(true);
    fetchData();
    setTimeout(() => {
      isShowLoader(false);
    }, 1000);
  }, []);
  return (
    <div className="mainbodycls">

      <section className="sub-banner">
        <div className="carouselinner">
          {bannerData.length > 0 && (
            <OwlCarousel
              class="owl-carousel owl-theme"
              loop
              margin={0}
              nav={false}
              dots={true}
              items={1}
              autoplay={true}
              autoplaySpeed={1200}
            >
              {bannerData.map((item, index) => (
                <div className="item" key={index}>
                  <img src={`${BASE_IMAGE_URL}${item.image}`} alt={item.title} />
                </div>
              ))}


            </OwlCarousel>
          )}
          <div class="subbannertext">
            <div className="container">
              <h1>Car <span className="bluee">Inspection</span><span className="bluee"></span></h1>
              <div className="bredcam">
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li>Car Inspection</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="inspectioncontainer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xxl-5 col-xl-6 col-lg-7 col-md-9 col-sm-11 col-12">
              <div className="usedcarbx">
                <div className="usedcarlt">
                  <img src={userCarsIcon} alt="User Icon" />
                </div>
                <div className="usedcarmd">
                  <h3>Used Car Inspection</h3>
                </div>
                <Link to="/car-inspection-details">
                  <div className="usedcarrt">
                    <strong><span>Pricing <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" /></svg>
                    </span></strong>

                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="siteheading text-center">
                <h3>{helpfulData.page_title}</h3>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="arpricing">
                <div dangerouslySetInnerHTML={{ __html: helpfulData?.page_content }} />
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="siteheading text-center">
                <h3>{factsData.page_title} </h3>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="arpricing">
                <div dangerouslySetInnerHTML={{ __html: factsData?.page_content }} />
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="siteheading text-center">
                <h2>What we cover in <span>Car Inspection</span></h2>
                <h3>Get 360° Inspection Assessment in Kolkata</h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-9 col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12">
              {/* <Markup content={coverData?.page_content} /> */}
              <div dangerouslySetInnerHTML={{ __html: coverData?.page_content }} />


            </div>
          </div>
        </div>
      </section>

      <section className="carpartscontainer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="carpartsbx">
                <img src={carPartsImage} alt="Car" />
                {interactiveData.map((interactive, index) => (
                  <span className={`carcheckbx ${interactive.class}`}>
                    <span className="carcheckbxct">
                      <span className="carpartstitle">{interactive.title}</span>
                      <span className="carpartsimg">
                        <img src={`${BASE_IMAGE_URL}${interactive.image}`} alt={interactive.title} />
                      </span>
                    </span>
                    <span className="carpartscontentbx">
                      <Markup content={interactive.description} />
                    </span>
                  </span>
                ))}

              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <a
                className="bookservicebtn"
                href="javascript:void(0);"
                onClick={() => setShowModal(true)}
              >
                Callback Request
              </a>
            </div>
          </div>
        </div>
      </section>

      {showModal && (
        <div className="modal fade show d-block callbackmodal" tabIndex="-1" role="dialog">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Request a Callback</h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Contact Number</label>
                    <input
                      type="text"
                      className="form-control"
                      name="contact"
                      value={formData.contact}
                      onChange={handleChange}
                      placeholder="Enter your contact number"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                  Close
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showModal && (<div class="modal-backdrop fade show"></div>)}

      <section className="howitcontainer">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-11 col-lg-10 col-md-12 col-sm-12 col-12">
              <div className="siteheading text-center">
                <h2>{howItsData?.page_title}</h2>
                <p>{howItsData?.short_description}</p>
                <p><strong>Lets break down the whole process in 4 simple steps.</strong></p>
              </div>
            </div>
          </div>
          <div className="row howitrow justify-content-center">
            <div dangerouslySetInnerHTML={{ __html: howItsData?.page_content }} />

          </div>
          <div className="row justify-content-center mt-3 mt-lg-5 mb-0 mb-lg-5">
            <div className="col-xxl-10 col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
              <a className="bookservicebtn d-inline-flex align-items-center justify-content-center gap-2" href="https://otobix.in/inspections/25_1_171974.pdf" target="_blank">SAMPLE INSPECTION REPORT
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-download-fill" viewBox="0 0 16 16">  <path fill-rule="evenodd" d="M8 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 4.095 0 5.555 0 7.318 0 9.366 1.708 11 3.781 11H7.5V5.5a.5.5 0 0 1 1 0V11h4.188C14.502 11 16 9.57 16 7.773c0-1.636-1.242-2.969-2.834-3.194C12.923 1.999 10.69 0 8 0m-.354 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 14.293V11h-1v3.293l-2.146-2.147a.5.5 0 0 0-.708.708z" /></svg>              </a>

            </div>
          </div>
          <div className="row justify-content-center mt-3 mt-lg-5 mb-0 mb-lg-5">
            <div className="col-xxl-10 col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="videobtm">
                <div class="ratio ratio-21x9">
                  <iframe src={urlData?.url} title="YouTube video" allowfullscreen></iframe>
                </div>
                <div className="text-center">
                  <Link className="bookservicebtn" to={`/car-inspection-details`}>Book a Service</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section >

      <FAQSection 
        faqData={FaqData.inspection} 
        title="Car Inspection - Frequently Asked Questions" 
        intro="Get a professional 140+ point inspection report for any used car. Our experts check everything from engine health to bodywork to ensure you make the right choice."
      />
    </div>
  )
}

export default CarInspection